module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-15.a2297de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-15.jpg
// module id = JiV6
// module chunks = 0